import React, { useEffect, useState } from "react";
import "./orders.scss";
import sidebarActivePage from "../../stores/sidebarActivePage";
import TwoBreadcrumb from "../../components/breadcrumbs/TwoBreadcrumb";
import { Box, Paper, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import paymentStore from "../../stores/paymentStore";
import orderStore from "../../stores/orderStore";
import usersStore from "../../stores/usersStore";
import productStore from "../../stores/productStore";
import AllOrderTab from "./orderTabs/AllOrderTab";
import PendingOrderTab from "./orderTabs/PendingOrderTab";
import ReturnedOrderTab from "./orderTabs/ReturnedOrderTab";
import DeliveredOrderTab from "./orderTabs/DeliveredOrderTab";
import PreparingOrderTab from "./orderTabs/PreparingOrderTab";
import OutOfDeliveryOrderTab from "./orderTabs/OutOfDeliveryOrderTab";
import OrderFilter from "./orderFilter/OrderFilter";
import orderDeliveryStatusTimeStore from "../../stores/orderDeliveryStatusTimeStore";

const Orders = () => {
  const PaymentStore = paymentStore();
  const OrderStore = orderStore();
  const UsersStore = usersStore();
  const ProductStore = productStore();
  const OrderDeliveryStatusTimeStore = orderDeliveryStatusTimeStore();

  const [allOrderCount, setAllOrderCount] = useState(0);
  const [pendingOrderCount, setPendingOrderCount] = useState(0);
  const [preparingOrderCount, setPreparingOrderCount] = useState(0);
  const [outOfDeliveryOrderCount, setOutOfDeliveryOrderCount] = useState(0);
  const [deliveredOrderCount, setDeliveredOrderCount] = useState(0);
  const [returnedOrderCount, setReturnedOrderCount] = useState(0);

  const [dataLoading, setDataLoading] = useState(true);

  const SidebarActivePage = sidebarActivePage();
  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "Orders" });
  }, []);

  const [activeTab, setActiveTab] = useState("1");

  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    if (
      !ProductStore.isLoading &&
      !PaymentStore.isLoading &&
      !OrderStore.isLoading &&
      !UsersStore.isLoading &&
      !OrderDeliveryStatusTimeStore.isLoading
    ) {
      const allRows = [];
      const pendingRows = [];
      const preparingRows = [];
      const outOfDeliveryRows = [];
      const deliveredRows = [];
      const returnedRows = [];
      if (PaymentStore.mPaymentDetails) {
        PaymentStore.mPaymentDetails.map((payment) => {
          let delivery_status = "";
          let delivery_status_time = "";
          OrderStore.orderDetail.map((order) => {
            if (payment._id === order.paymentID) {
              delivery_status = order.order_delivery_status;
            }

            OrderDeliveryStatusTimeStore.orderDeliveryStatusTime.map(
              (statusTime) => {
                if (statusTime._id === order.orderDeliveryStatusTimeID) {
                  delivery_status_time = statusTime.returning;
                }
              }
            );
          });
          if (delivery_status !== "") allRows.push(delivery_status);
          if (delivery_status === "Pending") {
            pendingRows.push(delivery_status);
          }
          if (delivery_status === "Preparing") {
            preparingRows.push(delivery_status);
          }
          if (delivery_status === "Out Of Delivery") {
            outOfDeliveryRows.push(delivery_status);
          }
          if (delivery_status === "Delivered") {
            deliveredRows.push(delivery_status);
          }
          if (delivery_status === "Return") {
            returnedRows.push(delivery_status);
          }
        });
      }
      setAllOrderCount(allRows.length);
      setPendingOrderCount(pendingRows.length);
      setPreparingOrderCount(preparingRows.length);
      setOutOfDeliveryOrderCount(outOfDeliveryRows.length);
      setDeliveredOrderCount(deliveredRows.length);
      setReturnedOrderCount(returnedRows.length);
      setDataLoading(false);
    }
  }, [
    ProductStore.isLoading,
    PaymentStore.isLoading,
    OrderStore.isLoading,
    UsersStore.isLoading,
    OrderDeliveryStatusTimeStore.isLoading,
    PaymentStore.mPaymentDetails,
    OrderStore.orderDetail,
    OrderDeliveryStatusTimeStore.orderDeliveryStatusTime,
  ]);

  const [orderID, setOrderID] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [staringDate, setStaringDate] = useState(null);
  const [endingDate, setEndingDate] = useState(null);
  const [staringPrice, setStaringPrice] = useState("");
  const [endingPrice, setEndingPrice] = useState("");
  const [deliveryStatus, setDeliveryStatus] = useState("");

  return (
    <div className="orders">
      <div className="heading">Orders</div>
      <TwoBreadcrumb mainName="Orders" mainLink="orders" activeName="List" />
      {activeTab === "1" && (
        <div className="filter-content">
          <OrderFilter
            orderID={orderID}
            setOrderID={setOrderID}
            customerName={customerName}
            setCustomerName={setCustomerName}
            staringDate={staringDate}
            setStaringDate={setStaringDate}
            endingDate={endingDate}
            setEndingDate={setEndingDate}
            staringPrice={staringPrice}
            setStaringPrice={setStaringPrice}
            endingPrice={endingPrice}
            setEndingPrice={setEndingPrice}
            deliveryStatus={deliveryStatus}
            setDeliveryStatus={setDeliveryStatus}
          />
        </div>
      )}
      <Paper sx={{ width: "100%", mb: 2, mt: 4 }}>
        <TabContext value={activeTab}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChangeTab}
              aria-label="lab API tabs example"
              className="tab-list"
              variant="scrollable"
            >
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "1" ? "active-all" : ""}>
                    All <span className="all">{allOrderCount}</span>
                  </p>
                }
                value="1"
              />
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "2" ? "active-pending" : ""}>
                    Pending <span className="pending">{pendingOrderCount}</span>
                  </p>
                }
                value="2"
              />
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "3" ? "active-preparing" : ""}>
                    Preparing{" "}
                    <span className="preparing">{preparingOrderCount}</span>
                  </p>
                }
                value="3"
              />
              <Tab
                className="tab"
                label={
                  <p
                    className={
                      activeTab === "4" ? "active-out-of-delivery" : ""
                    }
                  >
                    Out Of Delivery{" "}
                    <span className="out-of-delivery">
                      {outOfDeliveryOrderCount}
                    </span>
                  </p>
                }
                value="4"
              />
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "5" ? "active-delivered" : ""}>
                    Delivered{" "}
                    <span className="delivered">{deliveredOrderCount}</span>
                  </p>
                }
                value="5"
              />
              {/* <Tab
                className="tab"
                label={
                  <p className={activeTab === "6" ? "active-returned" : ""}>
                    Returned{" "}
                    <span className="returned">{returnedOrderCount}</span>
                  </p>
                }
                value="6"
              /> */}
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: 0 }}>
            <AllOrderTab
              dataLoading={dataLoading}
              orderID={orderID}
              customerName={customerName}
              staringDate={staringDate}
              endingDate={endingDate}
              staringPrice={staringPrice}
              endingPrice={endingPrice}
              deliveryStatus={deliveryStatus}
            />
          </TabPanel>
          <TabPanel value="2" sx={{ p: 0 }}>
            <PendingOrderTab dataLoading={dataLoading} />
          </TabPanel>
          <TabPanel value="3" sx={{ p: 0 }}>
            <PreparingOrderTab dataLoading={dataLoading} />
          </TabPanel>
          <TabPanel value="4" sx={{ p: 0 }}>
            <OutOfDeliveryOrderTab dataLoading={dataLoading} />
          </TabPanel>
          <TabPanel value="5" sx={{ p: 0 }}>
            <DeliveredOrderTab dataLoading={dataLoading} />
          </TabPanel>
          {/* <TabPanel value="6" sx={{ p: 0 }}>
            <ReturnedOrderTab dataLoading={dataLoading} />
          </TabPanel> */}
        </TabContext>
      </Paper>
    </div>
  );
};

export default Orders;
